<template>
    <div class="top-bar">
        <img src="../assets/image/logo.jpg" alt="" class="logo">
        <p class="name">{{info.nickName}}<img @click="loginOut" src="../assets/image/guanbi.png" class="login-out"/></p>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                info:{}
            }
        },
        methods: {
            loginOut(){
                let self=this;
                this.$Confirm({
                    title: '提示',
                    content: '确定要退出当前账号吗？',
                    onOk() {
                        return new Promise((resolve, reject) => {
                            self.$http({
                                method: 'post',
                                url: '/manager/admin/login/out',
                            }).then(function(res){
                                localStorage.removeItem('userInfo')
                                localStorage.removeItem('token')
                                self.$Message.success('退出成功')
                                resolve()
                                self.$router.replace({name:'login'})
                            }).catch(err=>{
                            })
                        }).catch(() => reject());
                    },
                    onCancel() {},
                });
            }
        },
        created() {
            this.info=JSON.parse(localStorage.getItem('userInfo'))
        },
    }
</script>
<style lang="less">
    div.top-bar{
        width:100%;
        height:90px;
        line-height:90px;
        padding:10px 20px;
        background: #2c3049;
        border-bottom:.5px solid #f1f1f1;
        position: fixed;
        left:0;
        top:0;
        z-index: 2;
        .logo{
            height:100%;
            float:left;
        }
        .name{
            float:right;
            font-size: 14px;
            color:#fff;
            position: relative;
            top:-10px;
            vertical-align: middle;
            img{
                width:14px;
                vertical-align: middle;
                position: relative;
                top:-2px;
                margin-left:6px;
                cursor:pointer;
            }
        }
    }
</style>